import { Component, OnInit } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { Persona } from 'se-resource-types/dist/lib/UserService'

const exampleHtml = `
<se-po-profile-bar
  [selfPersona]="selfPersona">
</se-po-profile-bar>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { Persona } from 'se-resource-types/dist/lib/UserService'

export class ProfileBarExampleComponent implements OnInit {
  public selfPersona: Persona

  public ngOnInit(): void {
    this.selfPersona = {
      id: 5,
      first_name:'Maame',
      last_name: 'Biney',
      profile_images: [
        {
          image_type: 'crop_icon',
          url: 'https://images.nbcolympics.com/sites/default/files/post/short_form_video/oly22_st_SMD_bineymini__635693.jpg'
        }
      ]
    } as Persona
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-profile-bar-example',
  template,
  styleUrls: ['./profile-bar-docs.component.scss'],
  standalone: false,
})
export class ProfileBarExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public selfPersona: Persona

  public ngOnInit(): void {
    this.selfPersona = {
      id: 5,
      first_name:'Maame',
      last_name: 'Biney',
      profile_images: [
        {
          image_type: 'crop_icon',
          url: 'https://images.nbcolympics.com/sites/default/files/post/short_form_video/oly22_st_SMD_bineymini__635693.jpg'
        }
      ]
    } as Persona
  }
}
